export class FetchPageLength {
  static readonly type = '[number] Fetch All';

  constructor(public payload: number) {
  }
}
